<section class="main-section">

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role == 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role == 'CUSTOMER_CARE'"><a
        routerLink="/admin/customercareOrders/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Products</li>
    </ol>
  </nav>

  <div class="invalid-feedback d-block shift-invalid-text w-75" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div>
    <div class="row align-items-center">
      <div class="col">
        <ul class="list-inline tab-list deskContent">
          <ng-container *ngFor="let om of inventoriesMainMenu">
            <li *ngIf="om.additional === 'N'" class="list-inline-item">
              <a (click)="populateTabData(om.tabClicked,om.orderStatus);"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
          </ng-container>
        </ul>
        <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
                [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;" required>
          <option *ngFor="let u of inventoriesMainMenu" [ngValue]="u.orderStatus">{{u.displayName}}</option>
        </select>
      </div>
      <div class="col-6 ml-auto text-right float-right" *ngIf="user.role == 'ROLE_ADMIN'">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button aria-haspopup="true" id="actions" data-toggle="dropdown" aria-expanded="false"
                  class="btn ml-2 btn-outline-primary dropdown-toggle"
                  *ngIf="(checkedList?.length) && tabClicked === 'active'">
            Actions
          </button>
          <div class="dropdown-menu dropdown-menu2  dropdown-menu-right"
               *ngIf="(checkedList?.length) && tabClicked !== 'all'">
            <a *ngIf="tabClicked === 'active'" id="qRCodeAndBarCodeAction"
               [ngClass]="{'disabled': checkedList?.length > 1}" (click)="printPopUp(products, 'qRCodeAndBarCode')"
               class="dropdown-item file btn shift-import">Generate Labels</a>
          </div>
          <a placement="bottom" ngbTooltip="Adjust Inventory" class="ml-3" id="add">
            <svg xmlns="http://www.w3.org/2000/svg" routerLink="/admin/adjustInventoryProduct" width="30" height="30"
                 viewBox="0 0 30 30">
              <defs>
                <style>.a {
                  fill: #8a55bb;
                }

                .b {
                  fill: #fff;
                }</style>
              </defs>
              <g transform="translate(-1113 -90)">
                <g transform="translate(1117 92.5)">
                  <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                </g>
                <g transform="translate(-50 8.375)">
                  <path class="b"
                        d="M10.074,1.919h-2.4a1.919,1.919,0,1,0-3.838,0h-2.4A1.44,1.44,0,0,0,0,3.358V13.912a1.44,1.44,0,0,0,1.439,1.439h8.635a1.44,1.44,0,0,0,1.439-1.439V3.358A1.44,1.44,0,0,0,10.074,1.919Zm-7.2,10.793a.72.72,0,1,1,.72-.72A.718.718,0,0,1,2.878,12.712Zm0-2.878a.72.72,0,1,1,.72-.72A.718.718,0,0,1,2.878,9.834Zm0-2.878a.72.72,0,1,1,.72-.72A.718.718,0,0,1,2.878,6.956ZM5.757,1.2a.72.72,0,1,1-.72.72A.718.718,0,0,1,5.757,1.2ZM9.594,12.233a.241.241,0,0,1-.24.24H5.037a.241.241,0,0,1-.24-.24v-.48a.241.241,0,0,1,.24-.24H9.354a.241.241,0,0,1,.24.24Zm0-2.878a.241.241,0,0,1-.24.24H5.037a.241.241,0,0,1-.24-.24v-.48a.241.241,0,0,1,.24-.24H9.354a.241.241,0,0,1,.24.24Zm0-2.878a.241.241,0,0,1-.24.24H5.037a.241.241,0,0,1-.24-.24V6a.241.241,0,0,1,.24-.24H9.354a.241.241,0,0,1,.24.24Z"
                        transform="translate(1172.947 88.617)"/>
                </g>
              </g>
            </svg>
          </a>
          <a placement="bottom" ngbTooltip="Import" data-toggle="modal" id="import" data-target="#buttonModal"
             class="ml-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
              <defs>
                <style>.a {
                  fill: #8a55bb;
                }

                .b {
                  fill: #fff;
                }</style>
              </defs>
              <g transform="translate(4 2.5)">
                <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                <path class="b"
                      d="M.457,8.222A.458.458,0,0,0,0,8.679v.914a.458.458,0,0,0,.457.457h3.2V8.222ZM14.417,3,11.622.2a.685.685,0,0,0-.485-.2h-.174V3.654h3.654V3.48A.683.683,0,0,0,14.417,3Zm-4.368.885V0H4.339a.684.684,0,0,0-.685.685V8.222H7.309V6.361a.458.458,0,0,1,.782-.323L10.82,8.793a.486.486,0,0,1,0,.685L8.088,12.23a.458.458,0,0,1-.782-.323V10.049H3.654v3.883a.684.684,0,0,0,.685.685h9.593a.684.684,0,0,0,.685-.685V4.568H10.734A.687.687,0,0,1,10.049,3.883Z"
                      transform="translate(3.356 5.479)"/>
              </g>
            </svg>
          </a>
          <a placement="bottom" ngbTooltip="Create" class="ml-3" id="submit">
            <svg xmlns="http://www.w3.org/2000/svg" (click)="submitAdmin()" width="30" height="30" viewBox="0 0 30 30">
              <defs>
                <style>.a {
                  fill: #8a55bb;
                }

                .b {
                  fill: #fff;
                }</style>
              </defs>
              <g transform="translate(4 2.5)">
                <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                <path class="b"
                      d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
                      transform="translate(2.823 3.938)"/>
              </g>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}"
           style="min-height:580px!important;">
        <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
          <tr>
            <th>SKU</th>
            <th>Customer</th>
            <th>Product Name</th>
            <th>Product Type</th>
            <th>Creation Date</th>
            <th>HSN</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let p of productsList;let i=index;">
            <td style="width:200px!important;">
              <div class="form-checkbox mr-2" *ngIf="tabClicked === 'active' && user.role == 'ROLE_ADMIN'">
                <input type="checkbox" id="{{p.productId}}" [(ngModel)]="p.isSelected" name="list_name"
                       (change)="selectShip(p)">
                <label for="{{p.productId}}"></label></div>
              <a routerLink="/admin/InventoriesView/{{p.productId}}" ngxClipboard
                 [cbContent]="p.storeSku">{{(p.storeSku ? (p.storeSku) : (p.sku))| uppercase}}</a>
              <img placement="bottom" ngbTooltip="Demo Order" class="ml-1 mb-1" id="demo2" src="assets/images/Demo.png"
                   width="20" height="20" *ngIf="p.accountType == 'DEMO_ACCOUNT'"></td>
            <td>
              <div class="text-truncate" style="width:100px;">{{p.ownerName | titlecase}}</div>
            </td>
            <td>
              <div class="textminwid" ngxClipboard [cbContent]="p.productName"
                   ngbTooltip="{{p.productName | titlecase}}">{{p.productName | titlecase}}</div>
            </td>
            <td>{{p.productType | titlecase}}</td>
            <td>{{p.createdDate}}</td>
            <td>{{p.hsnCode}}</td>
            <td>
              <div class="toggle-2">
                <input type="checkbox" name="onoffswitch" id="customSwitch1_{{p.productId}}"
                       class="custom-control-input" (click)="changeStatus(p,i)" [checked]="p.status==='ACTIVE'"
                       class="checkbox"/>
                <label for="customSwitch1_{{p.productId}}" class="toggle">
                  <span>ON</span><span>OFF</span>
                </label>
              </div>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr *ngIf="productsList?.length===0|| !productsList?.length">
            <td colspan="8" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="inner-box d-block d-sm-none">
        <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <th>SKU</th>
            <th>Customer</th>
            <th>Product Name</th>
            <th>Product Type</th>
            <th>Creation Date</th>
            <th>HSN</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let p of productsList;let i=index;">
            <td><b class=" tablesaw-cell-label">SKU</b>
              <span class="tablesaw-cell-content"><a
                routerLink="/admin/InventoriesView/{{p.productId}}">{{(p.storeSku ? (p.storeSku) : (p.sku)) | uppercase}}</a></span></td>
            <td><b class=" tablesaw-cell-label">Customer</b>
              <span class="tablesaw-cell-content">{{p.ownerName | titlecase}}</span></td>
            <td><b class=" tablesaw-cell-label">Product Name</b>
              <span class="tablesaw-cell-content">{{p.productName | titlecase}}</span></td>
            <td><b class=" tablesaw-cell-label">Product Type</b>
              <span class="tablesaw-cell-content">{{p.productType | titlecase}}</span></td>
            <td><b class=" tablesaw-cell-label">Creation Date</b>
              <span class="tablesaw-cell-content">{{p.createdDate}}</span></td>
            <td><b class=" tablesaw-cell-label">HSN</b>
              <span class="tablesaw-cell-content">{{p.hsnCode}}</span></td>
            <td>
              <b class=" tablesaw-cell-label">Status</b>
              <span class="tablesaw-cell-content">
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" (click)="changeStatus(p,i)"
                       id="customSwitch_{{p.productId}}" [checked]="p.status==='ACTIVE'">
                <label class="custom-control-label" for="customSwitch_{{p.productId}}"></label>
              </div>
              </span></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

<div class="modal fade" id="onHandQuantityModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">On Hand Quantity</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <table class="table p-5">
          <thead>
          <th>Warehouse Name</th>
          <th>Quantity</th>
          </thead>
          <tbody>
          <tr *ngFor="let p of onHandQuantityRecords">
            <td class="">{{p.warehouseName}}</td>
            <td class="">{{p.quantity}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-cancel" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="buttonModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Select Import</h4>
        <button type="button" (click)="reset()" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body ml-2">
        <div class="form-radio mr-5">
          <input type="radio" id="importProducts" name="skuConfig" (click)="removeFile()" [(ngModel)]="selectImport"
                 [ngModelOptions]="{standalone: true}" id="importProducts" required value="PRODUCTS">
          <label for="importProducts">Import Products
          </label>
        </div>
        <div class="form-radio mr-5">
          <input type="radio" id="importComponents" name="skuConfig" (click)="removeFile()" [(ngModel)]="selectImport"
                 [ngModelOptions]="{standalone: true}" id="importComponents" required value="COMPONENTS">
          <label for="importComponents">Import Components
          </label>
        </div>
      </div>

      <div class="modal-body ml-2" *ngIf="selectImport === 'PRODUCTS'">
        <h4 style="padding-inline:7px;">Import Products</h4>
        <div>
          <p style="font-size:15px; padding-inline:7px;">To import your Products, please create a CSV file with
            following details and upload.
            <br/>Sample file can be accessed <a
              href="https://shift-images.s3.ap-south-1.amazonaws.com/admin_products_import+(1).csv"
              target="_blank">here</a></p>
          <div class="row">
            <div class="col" style="height:44px; padding-right:23px;">
              <label class="import_products add_file">
                <input class="shift-import-input" type="file" (change)="loadorder($event)" [(ngModel)]="productImage"
                       [ngModelOptions]="{standalone: true}" name="file" accept="application/csv+json"/>
                <span *ngIf="!productImage || productImage == ''"> <img src="/./assets/images/Group_1645.svg"
                                                                        style="margin-right: 10px;" alt="productImage">Add file</span>
                <span *ngIf="productImage"><img src="/./assets/images/xx.png" style="margin-right: 10px;width:20px;"
                                                (click)="removeFile()" alt="productImage">{{getFileName(productImage)}}</span>

              </label>
              <div id="statusText2" class="invalid-feedback d-block mb-2" [hidden]="!statusText2">{{statusText2}}</div>
              <button type="button" *ngIf="productImage" style="margin-bottom:50px;"
                      class="btn btn-orange file shift-import ml-2" [attr.data-dismiss]="uploadDismissModal"
                      (click)="submitImportProduct()" data-toggle="modal" [attr.data-target]="uploadPopup">
                Import
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body ml-2" *ngIf="selectImport === 'COMPONENTS'">
        <h4 style="padding-inline:7px;">Import Product Components</h4>
        <div>
          <p style="font-size:15px; padding-inline:7px;">To import your Components, please create a CSV file with
            following details and upload.
            <br/>Sample file can be accessed <a
              href="https://shift-images.s3.ap-south-1.amazonaws.com/import-components.csv" target="_blank">here</a></p>
          <div class="row">
            <div class="col" style="height:44px; padding-right:23px;">
              <label class="import_products add_file">
                <input class="shift-import-input" type="file" (change)="loadorder($event)" [(ngModel)]="productImage"
                       [ngModelOptions]="{standalone: true}" name="file" accept="application/csv+json"/>
                <span *ngIf="!productImage || productImage == ''"> <img src="/./assets/images/Group_1645.svg"
                                                                        style="margin-right: 10px;" alt="productImage">Add file</span>
                <span *ngIf="productImage"><img src="/./assets/images/xx.png" style="margin-right: 10px;width:20px;"
                                                (click)="removeFile()" alt="productImage">{{getFileName(productImage)}}</span>

              </label>
              <div id="statusText1" class="invalid-feedback d-block mb-2" [hidden]="!statusText1">{{statusText1}}</div>
              <button type="button" *ngIf="productImage" style="margin-bottom:50px;"
                      class="btn btn-orange file shift-import ml-2" [attr.data-dismiss]="uploadDismissModal"
                      (click)="submitImportComponent()" data-toggle="modal" [attr.data-target]="uploadPopup">
                Import
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>

<!--display PrintPopUp-->
<div [ngStyle]="{'display': displayPopUP =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': displayPopUP == 'Y'}" class="modal" id="popUpHold" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleHoldLabel">Enter Quantity</h5>
        <button type="button" id="enterQuantity" class="close" (click)="closePopUp()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>

          <div calss="row">
            <div calss="col-md-4 required">
              <label *ngIf="printOptionType === 'QRCode'" id="numberOfQrCodes" class="control-label" for="quantity">Number
                of QRCodes to generate</label>
              <label *ngIf="printOptionType === 'Barcode'" id="numberOfBarCodes" class="control-label" for="quantity">Number
                of Barcodes to generate</label>
              <label *ngIf="printOptionType === 'qRCodeAndBarCode'" id="qRCodeAndBarCode" class="control-label"
                     for="quantity">No of Copies</label>
              <div class="form-group">
                <input type="text" id="quantity" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                       [(ngModel)]="quantity" id="quantity" class="form-control" (blur)="quantityBlur()"
                       [ngClass]="{'is-invalid':quantityError}"
                       [ngModelOptions]="{standalone: true}" required>
                <div id="quantityError" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!quantityError">{{quantityError}}</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="form-group required">
                <label class="control-label" for="printTypes">Print Option</label>
                <select class="form-control" id="printTypes" [(ngModel)]="printTypes"
                        [ngModelOptions]="{standalone: true}" [ngClass]="{'is-invalid':printOptionError}" required>
                  <option>24 labels with 63mm X 34mm</option>
                  <option>33 labels with 63mm X 34mm</option>
                  <option>40 labels with 63mm X 34mm</option>
                  <option>48 labels with 63mm X 34mm</option>
                  <option>Custom</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!printOptionError">{{printOptionError}}</div>
              </div>
            </div>
            <div class="col-6 mt-4 text-right">
              <button class="btn btn-cancel" type="button" (click)="clear()" aria-label="Close">Cancel</button>
              <button *ngIf="printOptionType === 'QRCode'" type="submit" class="btn btn-orange ml-1"
                      (click)="openQRCodePopup()">Submit QR
              </button>
              <button *ngIf="printOptionType === 'Barcode'" type="submit" class="btn btn-orange ml-1"
                      (click)="openBarcodePopup()">Submit Barcode
              </button>
              <button *ngIf="printOptionType === 'qRCodeAndBarCode'" type="submit" class="btn btn-orange ml-1"
                      (click)="qRCodeAndBarCodePopup()">Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
